import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "dialog"]

  close() {
    // Navigate to the backdrop link (which goes back to the board)
    if (this.hasBackdropTarget) {
      this.backdropTarget.click()
    }
  }

  clickOutside(event) {
    // Only close if clicking the backdrop, not the dialog
    if (this.hasDialogTarget && !this.dialogTarget.contains(event.target)) {
      // Check if the click was on the backdrop link itself
      if (event.target === this.backdropTarget || this.backdropTarget?.contains(event.target)) {
        // Let the link handle the navigation
        return
      }
    }
  }
}
